import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'logged_out_retailers-previously_visited_details-action_unknown';

/**
 * Tracks details of previous visits to faire.com by logged-out users.
 */
export function trackLoggedOutRetailersPreviouslyVisitedDetails(
  path: string = '',
  Logged_in_visit_count2: string = '',
  Logged_out_visit_count3: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { path, Logged_in_visit_count2, Logged_out_visit_count3 },
  });
}
